import MDBox from "components/Basics/MDBox";
import SiteMapImport from "./components/SiteMapImport";
import ShopifySelection from "./components/Shopify";
import WebImport from "./components/WebImport";
import { t } from "i18next";
import WordpressPageImport from "./components/WordpressPage";

/**
 * Import files URL
 * @param {*} param0
 * @returns {JSX.Element} StepImport
 */
export default function StepImport({ skeleton, format = "WebPage", validStep, handleSave }) {
	// Save files
	const onFilesSelection = async files => {
		handleSave(files);
	};

	// All possible selection methods
	const getSelectionMethod = () => {
		switch (format) {
			case "wordpressPage": {
				return <WordpressPageImport onFilesSelection={onFilesSelection} validStep={validStep} />;
			}
			case "WebPage": {
				return <WebImport onFilesSelection={onFilesSelection} validStep={validStep} />;
			}
			case "sitemap": {
				return <SiteMapImport onFilesSelection={onFilesSelection} validStep={validStep} />;
			}
			case "shopifyPage": {
				return <ShopifySelection onFilesSelection={onFilesSelection} validStep={validStep} />;
			}
			default:
				return <MDBox>{t("SOURCES.notValidMethod")}</MDBox>;
		}
	};

	return (
		<MDBox flex="1" display="flex" flexDirection="row" style={{ height: "100%", width: "100%" }}>
			{getSelectionMethod(skeleton.importMethod)}
		</MDBox>
	);
}
